module.exports = __webpack_public_path__ + "img/230946361.f3a6bd24.svg";